var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-footer"},[(!_vm.fixed)?_c('div',{staticClass:"box",style:(`height: ${_vm.height + 16}px`)}):_vm._e(),(!_vm.fixed)?_c('div',{ref:"main",staticClass:"main"},[_vm._t("default")],2):_vm._e(),(_vm.fixed)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }